import { useScrollPastHero } from '@apps/guest/packages/layout-engine/layouts/hooks/useScrollPastHero';

const SCROLL_THRESHOLD = 100;

export const useMenuButtonScroll = () => {
  const { isPastThreshold } = useScrollPastHero({ threshold: SCROLL_THRESHOLD });
  return { hasScrolled: isPastThreshold };
};
